export class NewsletterSettingsForm {
	selectors = {
		periodInputs: Array.prototype.slice.call(
			document.querySelectorAll(".js-newsletter-settings__period-input")
		),
		disableInput: document.querySelector(
			".js-newsletter-settings__disable-input"
		),
		pauseWrapper: document.querySelector(".js-newsletter-settings__pause"),
		pauseInputs: Array.prototype.slice.call(
			document.querySelectorAll(".js-newsletter-settings__pause-input")
		),
	};

	constructor() {
		this.bindPauseInputs();
		this.bindPauseBlockToggle();
	}

	bindPauseBlockToggle() {
		if (this.selectors.disableInput) {
			this.selectors.disableInput.addEventListener("change", () => {
				this.selectors.pauseWrapper.classList.remove("is-hidden");

				this.selectors.pauseInputs.forEach((element) => {
					element.classList.remove("is-active")
					element.querySelector("input").checked = false;
				});

				// check first
				this.selectors.pauseInputs[0].classList.add("is-active")
				this.selectors.pauseInputs[0].querySelector("input").checked = true;
			});
		}

		this.selectors.periodInputs.forEach((x) => {
			x.addEventListener("change", () => {
				this.selectors.pauseWrapper.classList.add("is-hidden");

				// uncheck all
				this.selectors.pauseInputs.forEach((element) => {
					element.classList.remove("is-active")
					element.querySelector("input").checked = false;
				});
			});
		});
	}

	bindPauseInputs() {
		this.selectors.pauseInputs.forEach((element) => {
			element
				.querySelector("input")
				.addEventListener("change", (event) => {
					// deactivate all
					this.selectors.pauseInputs.forEach((x) =>
						x.classList.remove("is-active")
					);

					// activate current
					event.target.value
						? element.classList.add("is-active")
						: element.classList.remove("is-active");
				});
		});
	}
}

window.NewsletterSettingsForm = new NewsletterSettingsForm();
